// ====================================================================================
// swiper1.module
// ====================================================================================
import Swiper from "swiper";
import { Pagination, A11y, Keyboard } from "swiper/modules"; // Pagination, Scrollbar

export const init = function () {
  const swiperContainers = document.querySelectorAll(".swiper-container--1");

  swiperContainers.forEach(function (slider) {
    let attempts = 0;
    let cID = slider.getAttribute("id");

    let swiper = new Swiper(`#${cID}`, {
      modules: [Pagination, Keyboard, A11y],
      rewind: true,
      enabled: true,
      speed: 500,
      initialSlide: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      slidesOffsetAfter: 50,
      spaceBetween: 20,
      pagination: {
        el: `#${cID} .swiper-pagination`,
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className} dot">${index}</span>`;
        },
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      breakpoints: {
        // when window width is >= 768px
        768: {
          centeredSlides: false,
          spaceBetween: 0,
          enabled: false,
        },
      },
      on: {
        afterInit: function (swiper) {
          document.querySelector(`#${cID}`).classList.add("slider-init");
          swiper.updateSize();
          swiper.updateSlides();
        },
        beforeSlideChangeStart: function (swiper) {
          let slide = swiper.slides[swiper.activeIndex];
          let tooltips = slide.querySelectorAll('[data-bs-toggle="tooltip"].open');
          tooltips.forEach(function (tooltip) {
            tooltip.click();
          });
        },
      },
    });

    swiper.updateSize();
    swiper.updateSlides();

    // if document.ready needed
    const whenComplete = () => {
      if (attempts > 30) return;
      attempts += 1;
      if (document.readyState === "complete") {
        swiper.update();
        swiper.updateSize();
        swiper.updateSlides();

        window.addEventListener("resize", function () {
          if (window.innerWidth > 767) {
            swiper.slideTo(0, 0);
            swiper.slideReset(0);
          }
        });
      } else {
        setTimeout(function () {
          whenComplete();
        }, 400);
      }
    };
    whenComplete();
  });
};
